// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1ncL4","addWidgetButton":"Header_addWidgetButton__2CiwZ","dashboardTabs":"Header_dashboardTabs__t5oRL","active":"Header_active__1L1s7"};